import RotateDevice from "./presentational";
export default RotateDevice;
